import { useShigoSession } from '../../lib/useShigoSession';
import { isNetworkFeatureAllowed, type NetworkAvailableFeature } from './networkFeatures';

export function useNetworkFeatures() {
  const { session } = useShigoSession();

  return {
    features: session?.user.networkFeatures ?? [],
    isFeatureAllowed: (feature: NetworkAvailableFeature) =>
      Boolean(session && isNetworkFeatureAllowed(session.user, feature)),
  };
}
